import { render, staticRenderFns } from "./ChickenActivity.vue?vue&type=template&id=0f90cb0b&scoped=true&"
import script from "./ChickenActivity.vue?vue&type=script&lang=js&"
export * from "./ChickenActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f90cb0b",
  null
  
)

export default component.exports